import style from "../css/Thanku.module.css";
import Header from "../../Questions/component/Header";
import { IndianRupee, MapPin, Pencil } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useEffect, useState, useRef, useCallback } from "react";
import UAParser from "ua-parser-js";
import congrats from "../../../icons/congrats1.png";
import Fail from "../../SuccessFail/component/Fail";
import load from "../../../icons/preloader.svg";
import {
  offerEvent,
  getCheckoutStatus,
  CheckHotDealsOrderStatus,
  productEvent,
  updateFanduPoints,
  sendPaymentMode,
} from "../../../utils/api";
import coin from "../../../icons/coin.svg";

import { v4 as uuidv4 } from "uuid";
import { Col, Row } from "reactstrap";
import { Base2 } from "../../../utils/config";
import { useLocation } from "react-router-dom";

import gpay from "../../../icons/gpay.webp";
import paytm from "../../../icons/paytm.webp";
import phonpe from "../../../icons/phonepe.webp";
import bheem from "../../../icons/bhim.webp";
import other from "../../../icons/upi.webp";
import { ChevronRight } from "lucide-react";

export default function PaymentPage() {
  const [isUpiPopup, setUpiPopup] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  const pollingRef = useRef(null);
  const timeoutRef = useRef(null);

  const retryInterval = 3000;
  const maxDuration = 30000;

  const [savedAddress, setSavedAddress] = useState({});
  const [paymentLink, setPaymentLink] = useState("");
  const [isLoading, setLoading] = useState(false);
  const [upiStatus, setUpiStatus] = useState("pending");

  let mId = localStorage.getItem("mId") || "2026";
  let uuid = localStorage.getItem("uuid");
  let session_id = localStorage.getItem("session_id");

  const selectedProduct = JSON.parse(localStorage.getItem("productData")) || [];

  const userDetails = JSON.parse(localStorage.getItem("savedAddress")) || {};

  const stopPaymentPolling = useCallback(() => {
    if (pollingRef.current) {
      clearInterval(pollingRef.current);
      pollingRef.current = null;
    }

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
  }, []);

  const offerRequestData = (eventMetaData) => {
    const parser = new UAParser();
    const result = parser.getResult();

    return {
      machine_id: mId,
      device_id: uuid,
      session_id,
      ip_address: localStorage.getItem("ip_address"),
      lat: "",
      lng: "",
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      firstname: "",
      lastname: "",
      email: "",
      phone: "",
      deviceBrand: result.device.vendor || "Unknown",
      deviceModel: result.device.model || "Unknown",
      deviceType: result.device.type || "desktop",
      osName: result.os.name || "Unknown",
      osVersion: result.os.version || "Unknown",
      browserName: result.browser.name || "Unknown",
      browserVersion: result.browser.version || "Unknown",
      event_ts: Date.now().toString(),
      user_id: localStorage.getItem("userId") || "",
      ...eventMetaData,
    };
  };

  const avail = (EventName, EventSubName, EventType, EventSubType) => {
    const requestData = offerRequestData({
      Event_Name: EventName,
      Event_Sub_Name: EventSubName,
      Event_Type: EventType,
      Event_Sub_Type: EventSubType,
    });

    offerEvent(requestData);
  };

  useEffect(() => {
    avail("Payment_Page", "Address_Payment_Page", "Page_Open", "Order");
  }, []);

  useEffect(() => {
    const updatedAddress =
      JSON.parse(localStorage.getItem("savedAddress")) || {};

    setSavedAddress(updatedAddress);
  }, [location.pathname]);

  useEffect(() => {
    return () => {
      stopPaymentPolling();
    };
  }, [stopPaymentPolling]);

  const generateOrderSessionId = useCallback((mId) => {
    const uuid = uuidv4();
    const timestamp = Date.now().toString();

    const orderId = `${uuid.substring(0, 24)}${mId.substring(
      0,
      12,
    )}-${timestamp}`;

    return orderId;
  }, []);


  const checkOrderStatus = async (status) => {
    try {
      const data = {
        order_id: localStorage.getItem("HD_id"),
        hd_order_id: localStorage.getItem("HD_order_id"),
        status,
      };

      const response = await CheckHotDealsOrderStatus(data);

      if (response?.is_success === true) {
        await rewardOrderPoints();

        navigate("/order-confirmed");
      }
    } catch {
      setUpiStatus("timeout");
      setLoading(false);
    }
  };

  const rewardOrderPoints = async () => {
    try {
      const fanduUserId = localStorage.getItem("fanduUserId");

      if (!fanduUserId) return;

      const orderId = localStorage.getItem("HD_order_id");

      const rewardedOrders =
        JSON.parse(localStorage.getItem("rewardedOrders")) || [];

      if (rewardedOrders.includes(orderId)) {
        return;
      }

      const response = await updateFanduPoints({
        user_id: fanduUserId,
        score: 100,
        remark: "Hot Deals Order Reward",
      });

      const updatedPoints = Number(response?.score) || 0;

      localStorage.setItem("userFanduPoints", updatedPoints);

      localStorage.setItem(
        "rewardedOrders",
        JSON.stringify([...rewardedOrders, orderId]),
      );
    } catch (error) {
      console.log("Order reward error", error);
    }
  };

  async function getPaymentStatus() {
    try {
      const data = {
        order_id: localStorage.getItem("HD_order_id"),
        machine_id: "2026",
      };

      const response = await getCheckoutStatus(data);

      const transactionStatusId = response?.transaction_status_id;

      if (transactionStatusId === 1) {
        return { status: 1, response };
      }

      if (transactionStatusId === 2) {
        return { status: 0, response };
      }

      return { status: 3, response };
    } catch {
      return { status: "error" };
    }
  }

  const fanduPoints = localStorage.getItem("userFanduPoints") || "0";

  const startPaymentStatusPolling = useCallback(() => {
    stopPaymentPolling();

    let isChecking = false;

    setUpiPopup(true);
    setLoading(true);
    setUpiStatus("pending");

    pollingRef.current = setInterval(async () => {
      if (isChecking) return;

      isChecking = true;

      try {
        const result = await getPaymentStatus();

        if (!result) {
          isChecking = false;
          return;
        }

        if (result.status === 1) {
          stopPaymentPolling();

          localStorage.removeItem("hotDealsCart");

          setUpiStatus(1);
          setLoading(false);

          await checkOrderStatus("success");

          localStorage.removeItem("productData");
          localStorage.removeItem("savedAddress");
          localStorage.removeItem("HD_id");
          localStorage.removeItem("HD_order_id");
          localStorage.removeItem("editUserDetailsId");
          localStorage.removeItem("order_session_id");
          localStorage.removeItem("hotDeals_upi_type");

          return;
        }

        if (result.status === 2) {
          stopPaymentPolling();

          setUpiStatus(0);
          setLoading(false);

          await checkOrderStatus("fail");

          return;
        }

        if (result.status === 3) {
          setUpiStatus("pending");
          setLoading(true);
        }
      } catch {
        stopPaymentPolling();
        setUpiStatus("timeout");
        setLoading(false);
      } finally {
        isChecking = false;
      }
    }, retryInterval);

    timeoutRef.current = setTimeout(() => {
      stopPaymentPolling();
      setUpiStatus("timeout");
      setLoading(false);
    }, maxDuration);
  }, [stopPaymentPolling]);

  const getPaymentMode = async (upi, mode) => {
    try {
      const data = {
        device_id: uuid,
        order_id: localStorage.getItem("HD_order_id"),
        payment_method: mode,
        payment_mode: upi,
        amount: selectedProduct?.[0]?.pd_price,
        product_id: selectedProduct?.[0]?.product_id,
        firstname: userDetails?.name,
        email: "",
        phone: userDetails?.phone,
        session_id: session_id,
        order_session_id: generateOrderSessionId(mId),
        machine_id: "2026",
        machine_type: "HD",
        user_id: localStorage.getItem("userId"),
      };

      return await sendPaymentMode(data);
    } catch {
      return null;
    }
  };

  const onUPIClick = useCallback(
    async (upi, type) => {
      try {
        localStorage.setItem("hotDeals_upi_type", upi);

        const parser = new UAParser();
        let result = parser.getResult();

        const upiId = await getPaymentMode(upi, type);

        if (!upiId?.upi_address) {
          setUpiStatus("timeout");
          return;
        }

        const payeeName = "PunnyaDhara";
        const amount = selectedProduct?.[0]?.pd_price;

        const transactionRef = localStorage.getItem("HD_order_id");

        const note = "Payment-for-Hot-Deal_" + upi;

        const currency = "INR";

        let upiUrl = "";

        if (type !== "cash") {
          upiUrl = `${upi}://${upi === "tez" ? "upi/" : ""}pay?pa=${
            upiId.upi_address
          }&pn=${payeeName}&tr=${transactionRef}&tn=${note}&am=${amount}&mam=${amount}&cu=${currency}`;

          setPaymentLink(upiUrl);

          setUpiPopup(true);

          startPaymentStatusPolling();

          window.location.href = upiUrl;
        } else {
          upiUrl = `${Base2}success/`;

          setPaymentLink(upiUrl);

          window.location.href = upiUrl;
        }

        const data = {
          machine_id: "2026",
          device_id: localStorage.getItem("uuid"),
          session_id: localStorage.getItem("session_id"),
          ip_address: localStorage.getItem("ip_address"),
          lat: "",
          lng: "",
          timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
          firstname: userDetails.name,
          lastname: "",
          email: "",
          phone: userDetails.phone,
          upi_address: upiId.upi_address,
          user_id: localStorage.getItem("userId"),

          deviceBrand: result.device.vendor || "Unknown",
          deviceModel: result.device.model || "Unknown",
          deviceType: result.device.type || "desktop",
          osName: result.os.name || "Unknown",
          osVersion: result.os.version || "Unknown",
          browserName: result.browser.name || "Unknown",
          browserVersion: result.browser.version || "Unknown",

          event_name: "HD_PaymentMode_Page",
          event_sub_name: "HD_PaymentMode_Page",
          event_type: "HD_Payment-Method-Impression",
          event_sub_type: "HD_paymentMethod_click",

          event_metadata: {
            machine_type: "HD",
            payment_method: type,
            payment_mode: upi,
          },

          event_ts: Date.now().toString(),
        };

        productEvent(data);
      } catch {
        setUpiStatus("timeout");
        setLoading(false);
      }
    },
    [selectedProduct, userDetails, mId, startPaymentStatusPolling],
  );

  return (
    <div className={style.homeContainer}>
      <Header fanduPoints={fanduPoints} avail={avail} />

      {savedAddress.name ? (
        <div className={style.checkoutWrapper}>
          <div className={style.addressSection}>
            <div className={style.addressHeader}>
              <div className={style.addressLeft}>
                <MapPin className={style.addressIcon} />
                <h2 className={style.addressTitle}>Delivery Address</h2>
              </div>

              <button
                className={style.editAddressBtn}
                onClick={() => navigate("/user-details")}
              >
                <Pencil className={style.editIcon} />
                Edit Address
              </button>
            </div>

            <div className={style.userInfo}>
              <h3 className={style.userName}>
                {savedAddress?.name} | {savedAddress?.phone}
              </h3>

              <p className={style.userAddress}>
                {savedAddress?.flat}, {savedAddress?.area}, {savedAddress?.city}
                , {savedAddress?.landmark} {savedAddress?.pincode},{" "}
                {savedAddress?.state}
              </p>
            </div>
          </div>

          <div className={style.summaryCard} style={{ marginBottom: "5px" }}>
            <div className={style.summaryHeader2} style={{ color: "#406bb0" }}>
              <span>Estimated Delivery Time</span>
              <span>3 Days</span>
            </div>
          </div>

          <div className={style.summaryCard}>
            <div className={style.summaryHeader}>
              <span>Product Detail</span>
              <span>Price</span>
            </div>

            <div className={style.summaryRow}>
              <span>{selectedProduct?.[0]?.product_name}</span>

              <span>
                <IndianRupee size={18} />
                {selectedProduct?.[0]?.pd_price}
              </span>
            </div>

            <div className={style.summaryDivider} />

            <div className={style.chargeRow}>
              <span>Delivery Charges</span>

              <span className={style.freeCharge}>
                <IndianRupee size={18} />0
              </span>
            </div>

            <div className={style.totalRow}>
              <span>Total Payable</span>

              <span className={style.totalPay}>
                <IndianRupee size={18} />
                {selectedProduct?.[0]?.pd_price}
              </span>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
            }}
          >
            <img src={coin} style={{ width: "16px" }} />
            <p className={style.earnPts}>Earn 100 FP on this purchase</p>
          </div>
        </div>
      ) : (
        <img src={congrats} className={style.bannerImg5} />
      )}

      <div className={`${style.billingPanel} ${style.open}`}>
        <div className={style.paymentHeader}>Select Your Payment Mode</div>

        <div className={style.upiIcons}>
          <Row className={style.upiRow}>
            <Col xs={12}>
              <div
                onClick={() => onUPIClick("tez", "UPI")}
                className={style.upiIconImages}
              >
                <div className={style.paymentName}>
                  <img src={gpay} className={style.upiImage} />

                  <p className={style.paymentMethodText}>Google Pay UPI</p>
                </div>

                <ChevronRight
                  className={style.cartChevron}
                  style={{ color: "black" }}
                />
              </div>

              <div className={style.divider} />
            </Col>
          </Row>

          <Row className={style.upiRow}>
            <Col xs={12}>
              <div
                onClick={() => onUPIClick("paytmmp", "UPI")}
                className={style.upiIconImages}
              >
                <div className={style.paymentName}>
                  <img src={paytm} className={style.upiImage} />

                  <p className={style.paymentMethodText}>Paytm UPI</p>
                </div>

                <ChevronRight
                  className={style.cartChevron}
                  style={{ color: "black" }}
                />
              </div>

              <div className={style.divider} />
            </Col>
          </Row>

          <Row className={style.upiRow}>
            <Col xs={12}>
              <div
                onClick={() => onUPIClick("phonepe", "UPI")}
                className={style.upiIconImages}
              >
                <div className={style.paymentName}>
                  <img src={phonpe} className={style.upiImage} />

                  <p className={style.paymentMethodText}>Phone Pe UPI</p>
                </div>

                <ChevronRight
                  className={style.cartChevron}
                  style={{ color: "black" }}
                />
              </div>

              <div className={style.divider} />
            </Col>
          </Row>

          <Row className={style.upiRow}>
            <Col xs={12}>
              <div
                onClick={() => onUPIClick("bhim", "UPI")}
                className={style.upiIconImages}
              >
                <div className={style.paymentName}>
                  <img src={bheem} className={style.upiImage} />

                  <p className={style.paymentMethodText}>Bhim UPI</p>
                </div>

                <ChevronRight
                  className={style.cartChevron}
                  style={{ color: "black" }}
                />
              </div>

              <div className={style.divider} />
            </Col>
          </Row>

          <Row className={style.upiRow}>
            <Col xs={12}>
              <div className={style.upiIconImages}>
                <div className={style.paymentName}>
                  <img src={other} className={style.upiImage} />

                  <p className={style.paymentMethodText}>UPI Pay</p>
                </div>

                <ChevronRight
                  className={style.cartChevron}
                  style={{ color: "black" }}
                />
              </div>

              <div className={style.divider} />
            </Col>
          </Row>
        </div>
      </div>

      {isUpiPopup && (
        <div className={style.popupContainer}>
          {isLoading && upiStatus === "pending" && (
            <div className={style.backDiv}>
              <div className={style.loadingContainer}>
                <div className={style.loadingBox}>
                  <img src={load} className={style.loaderImg} alt="loading" />
                </div>

                <p className={style.loadingText}>
                  Waiting for payment confirmation...
                </p>

                <span className={style.loadingSubText}>
                  Please complete payment in your UPI app
                </span>
              </div>
            </div>
          )}

          {!isLoading && upiStatus === 0 && <Fail />}

          {!isLoading && upiStatus === "timeout" && (
            <div className={style.backDiv}>
              <div className={style.loadingContainer}>
                <p className={style.loadingText}>
                  Payment status could not be determined
                </p>

                <span className={style.loadingSubText}>
                  Please try again in a few moments
                </span>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
